import React, { FC, PropsWithChildren } from 'react';
import classes from "./BackgroundShortz.module.css";

const BackgroundShortz:FC<PropsWithChildren> = ({children}) => {
  return (
    <div
    className={`${classes.background_wrapper}`}
  >
    <div className={`${classes.wrapper}`}>
      {children}
    </div>
  </div>
  )
}

export default BackgroundShortz